export default __webpack_public_path__ + "static/syncstage-built-for-speed-f36aa23127ab8f9a81cb5436135902eb.png";